module.exports = __webpack_public_path__ + "img/appBg-customer-base--card.722dad1f.svg";